import React, {useEffect, useRef, useState} from 'react';
import {
    checkCurrUrlHasParam,
    checkNullArr,
    getArrLen,
    getJsonValue,
    getDefStr,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    setTabTitle
} from "../../../common/fusion-ui/utils/ReactUtils";
import {
    getSearchQueryFromUrl,
    getValidSearchTargetIdFromUrl,
    getValidSearchTargetIdNameFromUrl,
    getValidSearchTypeIdFromUrl,
    getValidSearchTypeIdNameFromUrl,
    isUrlSearchTargetIdValid,
    isUrlSearchTypeIdValid,
    printError,
    printLog,
    sendRequest
} from "../../utils/AppUtils";
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {
    AppInterface,
    DocPanel,
    ForumPage,
    InvalidPanel,
    MeetingsPage,
    MessagePage,
    PeerProfilesPage,
    ResourcesPage,
    SurveyPage,
    ThemedButton,
    WebMeetingPage
} from "../../index";
import {DashSearchModules, Keys, ModuleRouteUrls, Modules, ReqUrls} from "../../config/AppConfig";
import {Flexbox, Label, NullMsgLabel} from "../../../common/fusion-ui";
import {useConfig} from "../../context/ConfigProvider";
import {CssVariant, IconClass, Messages} from "../../../common/fusion-ui/config/FusionConfig";
import useScreenSize from "../../../common/fusion-ui/hook/useScreenSize";

const SearchPage = React.memo(() => {
    const TAG = "SearchPage";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, getConfig, updateConfig} = useConfig();
    const {isScreenUpSm} = useScreenSize();

    const bodyRef = useRef(null);

    const SHOW_CONTROLS = true;

    const moduleName = Modules.Search;

    const Fields = {
        recordList: 'recordList',
        searchStringVariants: 'searchStringVariants',
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        openCreateAlbumDialog: 'openCreateAlbumDialog',
        createAlbumDialog_editMode: 'createAlbumDialog_editMode',

        searchQuery: 'searchQuery',
        searchTypeId: 'searchTypeId',
        searchTypeName: 'searchTypeName',
        isSearchTypeIdValid: 'isSearchTypeIdValid',

        searchTargetId: 'searchTargetId',
        searchTargetName: 'searchTargetName',
        isSearchTargetIdValid: 'isSearchTargetIdValid',
    };
    const [fieldsData, setFieldsData] = useState({
        [Fields.isDataLoading]: true,
    });

    useEffect(() => {
        setTabTitle(getTabTitle(true));
        updateConfig(Keys.tracker_currPageModule, moduleName);
        updateConfig(Keys.tracker_currPageTag, TAG);
        performInitOps();
    }, []);

    useEffect(() => {
        setTabTitle(getTabTitle(true));
        // log('Title updated');
    }, [getField(Fields.searchQuery)]);

    return (<>
        <AppInterface label={getTabTitle()}
                      onDashSearchClick={(searchUrl, searchValue, params) => {
                          // log('onDashSearchClick.searchUrl:', searchUrl, 'searchValue:', searchValue, 'params:', params);
                          // performInitOps(searchUrl);
                      }}>
            <div className={'position-relative'}>
                <InvalidPanel
                    color={theme.text70}
                    success={getField(Fields.isDataFound)}
                    loading={getField(Fields.isDataLoading)}
                    msg={getField(Fields.dataLoadingMsg)}
                    show404Image={true}
                />

                {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) && <div className={``}>
                    <div className={'d-none mx-n1 mb-2 mt-n1 px-3 py-2 section rounded-3 border-primary'}>
                        <span className={'fw-bold'}>Search Query:</span> <span className={'text-black'}>{getField(Fields.searchQuery)}</span>
                        &nbsp;|&nbsp;<span className={'fw-bold'}>Search Module:</span> <span
                        className={'text-primary fw-semi-bold'}>{getField(Fields.searchTypeName)} <span
                        className={'text-gray fw-normal'}>({getField(Fields.searchTypeId)})</span></span>
                        &nbsp;|&nbsp;<span className={'fw-bold'}>Search Target:</span> <span
                        className={'text-success'}>{getField(Fields.searchTargetName)} <span className={'text-gray'}>({getField(Fields.searchTargetId)})</span></span>
                        &nbsp;&nbsp;&nbsp;<span className={'text-gray fs-sm-md'}>(for testing only)</span>
                    </div>

                    {/*records section*/}
                    <div>
                        {/*header*/}
                        <div className={"position-absolute"} style={{top: '-2.3rem', right: '-.1rem'}}>
                            <Flexbox>
                                {/* go to module button*/}
                                {!isScreenUpSm && <ThemedButton
                                    className={'px-2 py-1 rounded-3 text-nowrap td-underline fs-sm fw-semi-bold'}
                                    m={1}
                                    height={'28px'}
                                    outlined={true}
                                    borderWidth={0}
                                    variant={theme.primaryBlue}
                                    hoverBgColor={theme.primaryBlue20}
                                    hoverColor={theme.primaryBlue}
                                    rippleColor={theme.primaryBlue50}
                                    text={`Go to ${getField(Fields.searchTypeName, Modules.Home)}`}
                                    href={ModuleRouteUrls[getField(Fields.searchTypeName, Modules.Home)]}
                                    onClick={() => {
                                        updateConfig(Keys.config_TabBarTab, getField(Fields.searchTypeName, Modules.Home));
                                        updateConfig(Keys.config_navbarCurrPage, getField(Fields.searchTypeName, Modules.Home));
                                    }}
                                />}
                                {/* next-button */}
                                {/*<ThemedIconButton*/}
                                {/*    className={'p-1 text-nowrap fs-sm fw-semi-bold'}*/}
                                {/*    m={1}*/}
                                {/*    ml={2}*/}
                                {/*    height={'28px'}*/}
                                {/*    outlined={true}*/}
                                {/*    variant={theme.primaryBlue}*/}
                                {/*    disableVariant={'xl'}*/}
                                {/*    icon={"bi bi-arrow-right"}*/}
                                {/*    tooltip={"Next"}*/}
                                {/*    circular={false}*/}
                                {/*    disabled={!checkNullStr(getField(Fields.nextRecordId))}*/}
                                {/*    href={isBoolTrue(fromPage) ? `${GenRouteUrls.pp_internalPage}${getField(Fields.nextRecordId)}` : ''}*/}
                                {/*    onClick={() => fetchPageData(getField(Fields.nextRecordId), false)}/>*/}
                            </Flexbox>
                        </div>

                        {/*records*/}
                        <div className={'mx-n1 mt-n1 p-1'} ref={bodyRef}>
                            {renderSelectedSearchTypeRecords()}
                        </div>
                    </div>

                    {/*footer*/}
                    <div>
                        {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) &&
                            <div className={'my-2 px-1'}>
                                <Label className={'px-2 py-1 rounded-3'} textAt={'start'}
                                       color={'var(--infoDark)'} bgColor={'var(--info10)'}
                                       iconClass={`${IconClass.iButtonFill} me-1`}>
                                    {`Some search-queries may not be directly visible in the fields, but they might be available in some other fields. You can click on any record to see all the fields.`}
                                </Label>
                            </div>}
                    </div>
                </div>}
            </div>
        </AppInterface>
    </>)

    function renderSelectedSearchTypeRecords() {
        switch (getField(Fields.searchTypeName)) {
            case DashSearchModules.res.name:
                return renderResRecords();
            case DashSearchModules.doc.name:
                return renderDocRecords();
            case DashSearchModules.wm.name:
                return renderWmRecords();
            case DashSearchModules.meetings.name:
                return renderMeetingRecords();
            case DashSearchModules.df.name:
                return renderDfRecords();
            case DashSearchModules.srv.name:
                return renderSrvRecords();
            case DashSearchModules.pp.name:
                return renderPpRecords();
            case DashSearchModules.msg.name:
                return renderMsgRecords();
            default:
                return <NullMsgLabel className={''} color={theme.text}>
                    {getField(Fields.dataLoadingMsg, 'Invalid search query!')}
                </NullMsgLabel>;
        }
    }

    function renderResRecords() {
        return <div>
            <ResourcesPage
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                panelsData={{
                    [Modules.Publication]: getJsonValue(getField(Fields.recordList), Modules.Publication, []),
                    [Modules.Documents]: getJsonValue(getField(Fields.recordList), Modules.Documents, []),
                    [Modules.CaseStudy]: getJsonValue(getField(Fields.recordList), Modules.CaseStudy, []),
                    [Modules.Videos]: getJsonValue(getField(Fields.recordList), Modules.Videos, []),
                    [Modules.Images]: getJsonValue(getField(Fields.recordList), Modules.Images, []),
                    [Modules.UsefulLinks]: getJsonValue(getField(Fields.recordList), Modules.UsefulLinks, []),
                }}
            />
        </div>
    }

    function renderDocRecords() {
        return <div>
            <DocPanel
                showHeader={true}
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                searchString={getField(Fields.searchQuery)}
                loadingStatus={{loaded: true, success: true, msg: ''}}
            />
        </div>
    }

    function renderWmRecords() {
        return <div>
            <WebMeetingPage
                showHeader={true}
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                searchString={getField(Fields.searchQuery)}
                loadingStatus={{loaded: true, success: true, msg: ''}}
            />
        </div>
    }

    function renderMeetingRecords() {
        return <div>
            <MeetingsPage
                showHeader={true}
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                searchString={getField(Fields.searchQuery)}
                loadingStatus={{loaded: true, success: true, msg: ''}}
            />
        </div>
    }

    function renderDfRecords() {
        return <div>
            <ForumPage
                showHeader={true}
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                searchString={getField(Fields.searchQuery)}
                loadingStatus={{loaded: true, success: true, msg: ''}}
            />
        </div>
    }

    function renderSrvRecords() {
        return <div>
            <SurveyPage
                showHeader={true}
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                searchString={getField(Fields.searchQuery)}
                loadingStatus={{loaded: true, success: true, msg: ''}}
            />
        </div>
    }

    function renderPpRecords() {
        return <div>
            <PeerProfilesPage
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                searchString={getField(Fields.searchQuery)}
            />
        </div>
    }

    function renderMsgRecords() {
        return <div>
            <MessagePage
                fromSearchPage={true}
                showControls={SHOW_CONTROLS}
                recordList={getRecordList()}
                // recordList={MessagePageConfig}
            />
        </div>
    }

    function getRecordList() {
        return checkNullArr(getField(Fields.recordList)) ? getField(Fields.recordList) : [];
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getTabTitle(forBrowserTab = false) {
        let name = getField(Fields.searchTypeName) + '';
        name = name.toLowerCase().endsWith('s') ? name : name + 's';
        if (forBrowserTab) {
            return `Search${isFieldTrue(Fields.isSearchTypeIdValid) ? ` in ${name}` : ''}`;
        } else {
            // return `Search Results${isFieldTrue(Fields.isSearchTypeIdValid) ? ` for ${name}` : ''}`;
            return <span className={'fw-normal fs-normal'} style={{color: theme.text}}>
                Search Results{isFieldTrue(Fields.isSearchTypeIdValid) ?
                <span>
                    <span> for <span className={'fw-bold'}>{name}</span></span>
                    {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound) && getField(Fields.searchTypeId) != DashSearchModules.res.id)
                        && <span className={'fw-semi-boldx'}>&nbsp;
                            <span className={'text-nowrap fw-semi-bold py-1 fs-sm rounded-2'}
                                  style={{backgroundColor: theme.text10, color: theme.text60}}>
                                &nbsp;&nbsp;Matched results: <span style={{color: theme.text70}}>{getArrLen(getField(Fields.recordList))}</span>&nbsp;&nbsp;
                            </span>
                        </span>}
                </span>
                : ''}
            </span>;
        }
    }

    function performInitOps() {
        const fun = 'performInitOps:';
        try {
            if (!isFieldTrue(Fields.isDataFetched)) {
                updateField(Fields.isDataFetched, true);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.recordList, []);

                const queryParamFound = checkCurrUrlHasParam(Keys.urlParam_SearchQuery);
                const typeParamFound = checkCurrUrlHasParam(Keys.urlParam_SearchTypeId);
                const targetParamFound = checkCurrUrlHasParam(Keys.urlParam_SearchTargetId);

                const isTypeIdValid = isUrlSearchTypeIdValid();
                const isTargetIdValid = isUrlSearchTargetIdValid();

                const searchQuery = getSearchQueryFromUrl();

                log(fun, 'searchQuery:', searchQuery, 'queryParamFound:', queryParamFound, '\ntypeParamFound:', typeParamFound, 'targetParamFound:', targetParamFound, '\nisTypeIdValid:', isTypeIdValid, 'isTargetIdValid:', isTargetIdValid);

                //update-states
                updateField(Fields.searchQuery, searchQuery);
                updateField(Fields.isSearchTypeIdValid, isTypeIdValid);
                updateField(Fields.isSearchTargetIdValid, isTargetIdValid);

                if (queryParamFound && typeParamFound && targetParamFound && isTypeIdValid && isTargetIdValid) {
                    //get search-query & search-type from url
                    const searchTypeId = getValidSearchTypeIdFromUrl();
                    const searchTypeName = getValidSearchTypeIdNameFromUrl();
                    updateField(Fields.searchTypeId, searchTypeId);
                    updateField(Fields.searchTypeName, searchTypeName);
                    log(fun, 'searchTypeName:', searchTypeName, 'searchTypeId:', searchTypeId);
                    updateField(Fields.isDataFound, true);

                    //extract search-target from url
                    const searchTargetId = getValidSearchTargetIdFromUrl();
                    const searchTargetName = getValidSearchTargetIdNameFromUrl();
                    updateField(Fields.searchTargetId, searchTargetId);
                    updateField(Fields.searchTargetName, searchTargetName);
                    // log(fun,'searchTargetName:', searchTargetName, 'searchTargetId:', searchTargetId);


                    // updateField(Fields.isDataFound, true);
                    // updateField(Fields.isDataLoading, false);

                    const REQUEST_OPTIONS = {
                        searchQuery: searchQuery,
                        searchTypeId: searchTypeId,
                        searchTargetId: searchTargetId,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.searchPage__fetchMatchedData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast(message, CssVariant.success);

                                const recordList = getJsonValueFromNestedKeys(fetchedData, ['data', 'recordList'], []);
                                const searchStringVariants = getJsonValueFromNestedKeys(fetchedData, ['data', 'searchStringVariants'], []);
                                log(fun, 'fetchedData.recordList:', recordList, 'searchStringVariants:', searchStringVariants);

                                updateField(Fields.recordList, recordList);
                                updateField(Fields.searchStringVariants, searchStringVariants);
                                updateField(Fields.isDataLoading, false);
                            } else {
                                toast(getDefStr(message, Messages.noRecordsFound), CssVariant.danger);
                                updateField(Fields.isDataLoading, false);
                                updateField(Fields.dataLoadingMsg, getDefStr(message, Messages.noRecordsFound));
                            }
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                        }),
                    });
                } else {
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                    updateField(Fields.dataLoadingMsg, 'Invalid search query!');
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
        }
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default SearchPage;
